<template>
  <div>
    <v-app>
      <app-drawer app class="app--drawer" :show-drawer="showDrawer" />
      <app-toolbar app class="app--toolbar" @side-icon-click="handleDrawerVisiable" />
      <v-content>
        <router-view />
      </v-content>
        <!-- App Footer -->
        <v-footer inset app height="auto" elevation="4" class="white pa-3 app--footer">
          <v-spacer />
          <span class="caption mr-1">Desarrollado por PreOlix &copy; {{ new Date().getFullYear() }}</span>
        </v-footer>
      <!-- Go to top -->
      <app-fab />
      <!-- Loading -->
      <loading />
    </v-app>
  </div>
</template>

<script>
import AppDrawer from "@/components/AppDrawer";
import AppToolbar from "@/components/AppToolbar";
import AppFab from "@/components/AppFab";
import Loading from "@/components/Loading";

export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    Loading
  },
  data: () => ({
    showDrawer: true
  }),
  methods: {
    handleDrawerVisiable() {
      this.showDrawer = !this.showDrawer;
    }
  },
  created() {}
};
</script>

<style lang="sass" scoped>

.page-wrapper
  min-height: calc(100vh - 64px - 50px - 81px)

</style>
